<template>
  <div id="app" style="height: 100%">
    <el-scrollbar style="height: calc(100% + 17px);" ref="scroll">
      <!--<el-backtop target=".el-scrollbar__wrap">-->
        <!--<div class="vcode">-->
          <!--<img src="/static/images/home/changyiewm.png" alt="">-->
          <!--扫码下载APP-->
        <!--</div>-->
        <!--<div class="back-top">回到顶部</div>-->
      <!--</el-backtop>-->
      <router-view></router-view>
    </el-scrollbar>
  </div>
</template>

<script type="text/javascript">
  export default {
    components: {},
    data() {
      return {

      }
    },
    methods: {
      unicodeToChar(str){
        return eval("'" + str + "'");
      }
    },
    created() {
      this.sg.initSG();
    },
    mounted() {

      // var sessionId = localStorage.getItem("ms_sessionId");
      // if(sessionId == null || sessionId == '') {
      //   this.$http.post(SZH.assets.api + "/Market/GetSessionId", { }).then(result => {
      //      localStorage.setItem("ms_sessionId", result);
      //   }, () => { });
      // }
    },
    computed: {},
    watch: {
      '$route'() {
        this.$refs.scroll.wrap.scrollTop = 0;
      }
    }
  }
</script>

<style type="text/css" scoped>

  #app {
    height: 100%;
    overflow: hidden;
  }

  .el-backtop {
    width: auto;
    height: auto;
    border-radius: 0;
    display: block
  }

  .el-backtop > .vcode {
    text-align: center;
    width: 100px;
    min-height: 100px;
    padding: 5px;
    background-color: #F6F6F6;
    font-size: 14px;
    text-align: center;
    color: #000;
  }
  .el-backtop > .vcode > img {
    width: 100%;
  }

  .el-backtop > .back-top {
    padding: 10px;
    font-size: 14px;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue